var a = "createFromTemplateKey", e = [
  {
    name: "zaps",
    displayName: "Zaps",
    icon: "miscBoltAltFill"
  },
  {
    name: "tables",
    displayName: "Tables",
    icon: "navTables"
  },
  {
    name: "interfaces",
    displayName: "Interfaces",
    icon: "navInterfaces"
  },
  {
    name: "chatbots",
    displayName: "Chatbots",
    icon: "navAIChatbot"
  },
  {
    name: "canvases",
    displayName: "Canvases",
    icon: "navCanvas"
  }
];
export {
  a as LOCALSTORAGE_TEMPLATE_CREATE_KEY,
  e as ZSL_ASSET_TYPES
};
//# sourceMappingURL=constants.es.js.map
